module.exports = __webpack_public_path__ + "img/travelService-title.ae70359d.png";